import * as React from 'react'
import type { SVGProps } from 'react'

import { PijmaComponent } from '@pijma/helper-component'
import { CommonComponentProps } from '@pijma/hero-types'

export const IconRain = (
  props: SVGProps<SVGSVGElement> & CommonComponentProps,
) => (
  <PijmaComponent
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    as="svg"
    commonProps={props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 10C2 12.2091 3.79086 14 6 14H18.981C18.9915 14 19 13.9915 19 13.981C19 13.9716 19.007 13.9636 19.0163 13.9622C20.7045 13.7126 22 12.2576 22 10.5C22 8.567 20.433 7 18.5 7C18.4457 7 18.3916 7.00124 18.3379 7.00369C17.6451 7.03528 16.8817 6.61919 16.6467 5.9667C15.8137 3.65373 13.6 2 11 2C8.57629 2 6.48824 3.43709 5.54145 5.50566C5.38907 5.83859 5.09316 6.08594 4.74546 6.20069C3.15085 6.72694 2 8.22907 2 10ZM18.6291 12H6C4.89543 12 4 11.1046 4 10C4 9.11761 4.57276 8.36378 5.37224 8.09993C6.19717 7.82769 6.95457 7.22385 7.36001 6.33802C7.99324 4.95452 9.38726 4 11 4C12.7302 4 14.2087 5.09956 14.765 6.64438C15.3568 8.28751 17.0499 9.0645 18.429 9.00161C18.4524 9.00055 18.476 9 18.5 9C19.3284 9 20 9.67157 20 10.5C20 11.2515 19.4455 11.877 18.7238 11.9837C18.692 11.9884 18.6604 11.9938 18.6291 12Z"
      fill="currentColor"
    />
    <path
      d="M12.8944 17.4472C13.1414 16.9532 12.9412 16.3526 12.4472 16.1056C11.9532 15.8586 11.3525 16.0588 11.1055 16.5528L9.10555 20.5528C8.85856 21.0468 9.05878 21.6474 9.55276 21.8944C10.0467 22.1414 10.6474 21.9412 10.8944 21.4472L12.8944 17.4472Z"
      fill="currentColor"
    />
    <path
      d="M7.44719 16.1056C7.94117 16.3526 8.14139 16.9532 7.8944 17.4472L6.8944 19.4472C6.64741 19.9412 6.04674 20.1414 5.55276 19.8944C5.05878 19.6474 4.85856 19.0468 5.10555 18.5528L6.10555 16.5528C6.35254 16.0588 6.95321 15.8586 7.44719 16.1056Z"
      fill="currentColor"
    />
    <path
      d="M17.8944 17.4472C18.1414 16.9532 17.9412 16.3526 17.4472 16.1056C16.9532 15.8586 16.3525 16.0588 16.1055 16.5528L15.1055 18.5528C14.8586 19.0468 15.0588 19.6474 15.5528 19.8944C16.0467 20.1414 16.6474 19.9412 16.8944 19.4472L17.8944 17.4472Z"
      fill="currentColor"
    />
  </PijmaComponent>
)
